// @flow
import React from 'react';

import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { OffersGrid } from 'Components/widgets/offers-grid/OffersGrid';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';

type Props = {
  id?: string,
  offers: Array<{
    color?: string,
    commercialArgument?: string,
    description?: string,
    href?: string,
    id?: string,
    image?: string,
    legalInformation?: string,
    name?: string,
    timingArgument?: string,
  }>,
  title?: string,
};

export const OffersGridLine = ({ id, offers, title }: Props) => {
  if (!offers.length) {
    return null;
  }

  return (
    <SiteContainer className="Line" id={id}>
      <LineTitle>{title}</LineTitle>
      <OffersGrid offers={offers} />
    </SiteContainer>
  );
};
